/**
 * TanStack Query hooks for `kpi-instructions-shown-to-publisher`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	kpiInstructionsShownToPublisherQueryKeys,
	type CreateKpiInstructionsShownToPublisherBody,
	type ListKpiInstructionsShownToPublisherResponse,
	type KpiInstructionsShownToPublisherRow,
} from "./api";

export function useKpiInstructionsShownToPublisherList(): UseQueryResult<ListKpiInstructionsShownToPublisherResponse, Error> {
	return useQuery({
		queryKey: kpiInstructionsShownToPublisherQueryKeys.list(),
		queryFn: list,
	});
}

export function useKpiInstructionsShownToPublisherCreate(): UseMutationResult<KpiInstructionsShownToPublisherRow, Error, CreateKpiInstructionsShownToPublisherBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kpiInstructionsShownToPublisherQueryKeys.all });
		},
	});
}

export function useKpiInstructionsShownToPublisherDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kpiInstructionsShownToPublisherQueryKeys.all });
		},
	});
}
